<div class="wrapper" *ngIf="valuesMap.size > 0">
  <label class="labels" for="">Filtres:</label>
  <div class="values">
    <ng-container *ngFor="let item of valuesMap | keyvalue">
      <div class="value" *ngFor="let val of item.value">
        {{ resolveValue(item.key, val) }}
        <div class="delete" (click)="onDeleteValue(item.key, val)">
          <span class="cross"></span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
